import { TEACHER_ROUTE } from 'app/teacher/routing-constants/teacher-routing.constant';

export const MATHALON_ROUTE = {
  name: 'mathalon',
  route(classId: string): string[] {
    return [...TEACHER_ROUTE.ACTIVE_CLASS.route(classId), this.name];
  }
};
